import { Box } from '@chakra-ui/react';
import MapContainer from '@/components/map/map-container';
import MapDrawer from '@/components/map/map-drawer';
import MapLegend from '@/components/map/map-legend';
import ImportantInfoDialog from '@/components/important-info-dialog';
import { useMap } from '@/components/map/map-context';

const Map = () => {
  const { legendVisible, currentTheme } = useMap();

  const shouldShowLegend = () => {
    return legendVisible && currentTheme !== 'assoctheme';
  };

  return (
    <Box w='full' h='full' position='relative' overflow='hidden'>
      <MapContainer />
      <MapDrawer />
      <MapLegend
        theme={currentTheme}
        isVisible={shouldShowLegend()}
      />
      <ImportantInfoDialog />
    </Box>
  );
};

export default Map;
